import { Injectable, autobind } from '@kaokei/use-vue-service';
import { DaoService } from './dao.service';
import {
  removeToken,
  setLogin,
  removeLogin,
  TOKEN_INVALID_ERRCODE,
} from '@/utils';

import { UserInfo } from '@/types';

import Sentry from '@/utils/sentry';

const HEARTBEAT_GAP = 2 * 60 * 1000; // 每2分钟心跳检测一次

@Injectable()
export class UserService {
  public user?: UserInfo;
  /**
   * 禁止心跳检测
   *
   * @memberof UserService
   */
  public stopHeartBeatTimerFlag = true;
  /**
   * 心跳检测的定时器
   *
   * @memberof UserService
   */
  public timer = 0;

  constructor(public daoService: DaoService) {}

  public init() {
    return this.daoService
      .getCurrentUserInfoIgnoreError()
      .then(user => {
        this.user = user; // 设置当前用户信息
        setLogin(); // 标志当前用户已登录
        this.startHeartBeat();
        this.initSentryUser();
      })
      .catch(e => {
        removeLogin(); // 标志当前用户未登录
        removeToken(); // 删除token
        if (e && e.errCode === TOKEN_INVALID_ERRCODE) {
          Sentry.withScope(function (scope) {
            scope.setTag('api', 'getCurrentUserInfoIgnoreError');
            scope.setLevel(Sentry.Severity.Error);
            Sentry.captureException(e);
          });
        }
      });
  }

  public initUserInfo() {
    return this.daoService.getCurrentUserInfo().then(user => {
      this.user = user; // 设置当前用户信息
      setLogin(); // 标志当前用户已登录
      this.startHeartBeat();
      this.initSentryUser();
    });
  }

  public initSentryUser() {
    Sentry.setUser({
      userId: this.user?.userId,
    });
  }

  @autobind
  public logout() {
    this.daoService.logout();
    this.user = undefined;
    removeToken();
    removeLogin();
    this.stopHeartBeat();
    Sentry.setUser(null);
  }

  /**
   * 开始心跳检测
   *
   * @memberof UserService
   */
  public startHeartBeat() {
    if (this.stopHeartBeatTimerFlag) {
      this.stopHeartBeatTimerFlag = false;
      this.doHeartBeat();
    }
  }

  /**
   * 停止心跳检测
   *
   * @memberof UserService
   */
  public stopHeartBeat() {
    this.stopHeartBeatTimerFlag = true;
    window.clearTimeout(this.timer);
  }

  @autobind
  public doHeartBeat() {
    this.daoService.heartBeat().then(() => {
      // 2分钟后再次检测
      if (this.stopHeartBeatTimerFlag) return;
      // 清除可能存在的定时器
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(this.doHeartBeat, HEARTBEAT_GAP);
    });
  }
}
